// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import interfaces from "./utlis/network"
// import vConsole  from '../src/assets/js/vcconsole'

Vue.config.productionTip = false

import Store from "./store/store"
Vue.prototype.$store = Store

// 引入rem.js文件 和 base 文件
import './assets/js/rem.js'
import './assets/css/base.css'
// JsBridge
import bridge from "./assets/js/bridge.js" 
Vue.prototype.$bridge = bridge
Vue.prototype.$interfaces=interfaces


import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})







//引入mint-ui
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  Store,
  components: {App},
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js